import HTTPService from '../HTTPService'

class Scenarios {
  getAll (companySlug) {
    return HTTPService.get(`company/${companySlug}/scenario`)
  }

  addOne (companySlug, payload) {
    return HTTPService.post(`company/${companySlug}/scenario`, {
      name: payload.name,
      description: payload.description
    })
  }

  getOne (companySlug, scenarioSlug) {
    return HTTPService.get(`company/${companySlug}/scenario/${scenarioSlug}`)
  }

  updateOne (companySlug, scenarioSlug, payload) {

    const payloadData = {
      name: payload.name,
      description: payload.description,
      settings: {
        'client_close.enabled': payload.settings['client_close.enabled'],
        'manual_dialog_switch.enabled': payload.settings['manual_dialog_switch.enabled'],
        'message.not_found': payload.settings['message.not_found'],
        'message.manual_dialog': payload.settings['message.manual_dialog'],
        'message.operator_unavailable': payload.settings['message.operator_unavailable'],
        'general.max_unrecognized_inputs': payload.settings['general.max_unrecognized_inputs']
      }
    }

    if (payloadData.settings['client_close.enabled']) {
      payloadData.settings['client_close.keyword'] = payload.settings['client_close.keyword']
      payloadData.settings['client_close.title'] = payload.settings['client_close.title']
      payloadData.settings['client_close.message'] = payload.settings['client_close.message']
      payloadData.settings['manual_dialog_switch.enabled'] = payload.settings['manual_dialog_switch.enabled']
    }

    if (payloadData.settings['manual_dialog_switch.enabled']) {
      payloadData.settings['manual_dialog_switch.keyword'] = payload.settings['manual_dialog_switch.keyword']
      payloadData.settings['manual_dialog_switch.title'] = payload.settings['manual_dialog_switch.title']
      payloadData.settings['manual_dialog_switch.message'] = payload.settings['manual_dialog_switch.message']
    }

    return HTTPService.put(`company/${companySlug}/scenario/${scenarioSlug}`, payloadData)
  }

  deleteOne (companySlug, scenarioSlug) {
    return HTTPService.delete(`company/${companySlug}/scenario/${scenarioSlug}`)
  }
}

export default new Scenarios()
